import { Component } from '@angular/core';


@Component({
  selector: 'app-weekly-sells-reports',
  templateUrl: './weekly-sells-reports.component.html',
  styleUrls: ['./weekly-sells-reports.component.scss'],
})
export class WeeklySellsReportsComponent {
}
